import { Monogram } from "@/components/Logo";

export function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-pulse opacity-60">
        <Monogram size={48} />
      </div>
    </div>
  );
}
